import React from 'react';
import { createPortal } from 'react-dom';
import { AlertCircle, X } from 'lucide-react';
import { ConfirmationPayload } from '../../services/brunixStream';

interface ConfirmationModalProps {
  payload: ConfirmationPayload;
  onAccept: () => void;
  onReject: () => void;
}

export default function ConfirmationModal({ payload, onAccept, onReject }: ConfirmationModalProps) {
  return createPortal(
    <div className="bx-modal-overlay" onClick={onReject}>
      <div className="bx-modal" onClick={e => e.stopPropagation()}>

        <div className="bx-modal-header">
          <div className="bx-modal-title">
            <AlertCircle size={14} />
            <span>Review Planned Actions</span>
          </div>
          <button className="bx-modal-close" onClick={onReject}><X size={14} /></button>
        </div>

        {payload.message && (
          <p className="bx-modal-message">{payload.message}</p>
        )}

        {payload.plan?.length > 0 && (
          <ul className="bx-modal-plan">
            {payload.plan.map((step: any, i: number) => (
              <li key={i} className="bx-modal-plan-item">
                <span className="bx-modal-plan-reason">{step.reason ?? String(step)}</span>
                {step.tool && <span className="bx-modal-plan-tool">{step.tool}</span>}
              </li>
            ))}
          </ul>
        )}

        <div className="bx-modal-actions">
          <button className="bx-modal-reject" onClick={onReject}>Cancel</button>
          <button className="bx-modal-accept" onClick={onAccept}>Confirm</button>
        </div>

      </div>
    </div>,
    document.body
  );
}
